import React, { lazy } from "react";
import Page from "components/Page";
import { Props } from "./AdminUsers";
import { paths } from "appConstants";
import { PageProps } from "App";

const AdminUsers = lazy(() => import("./AdminUsers"));

export default (props: PageProps) => (
  <Page
    navType={props.navType}
    navData={props.navData}
    footerType={props.footerType}
    location={props.location}
  >
    <AdminUsers path={paths.adminUsers.url} {...props} />
  </Page>
);
